import { useMapTooltipDisplayData } from "../useMapTooltipDisplayData"

// RoadCategorySegments
export default function RCSContent() {
    const { displayData } = useMapTooltipDisplayData()
    const { RoadCategory } = displayData ?? {}
    
    return (
        <>
            <div className="tooltip-info-row">Категория: {RoadCategory ?? 'Не известна'}</div>
        </>
    )
}
